import { render } from "./Spazio.vue?vue&type=template&id=1df8fd0b&scoped=true"
import script from "./Spazio.vue?vue&type=script&lang=js"
export * from "./Spazio.vue?vue&type=script&lang=js"

import "./Spazio.vue?vue&type=style&index=0&id=1df8fd0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df8fd0b"]])

export default __exports__